import angular from "angular";
import core from "../../core/core.module";
import organization from "../organization";
import angularMoment from "angular-moment";
import angularUIB from "angular-ui-bootstrap";
import transactionInfo from "../transaction-info/transaction-info";

angular
    .module('organizationsControl.organizationTransactions', [core, organization, angularMoment, angularUIB, transactionInfo])
    .component('organizationTransactions', {
        controller: ['notifier', 'Organization', 'moment', '$uibModal', '$httpParamSerializer', controller],
        template: require('./organization-transactions.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&',
        }
    });

function controller(notifier, Organization, moment, $uibModal, $httpParamSerializer) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.organization = $ctrl.resolve.organization;
        $ctrl.startDate = moment().startOf('day').toDate();
        $ctrl.endDate = moment().endOf('day').seconds(0).milliseconds(0).toDate();
        $ctrl.getList();
    };

    $ctrl.clearDates = function () {
        $ctrl.startDate = null;
        $ctrl.endDate = null;
    };

    $ctrl.submitFilters = function () {
        $ctrl.getList();
    };

    $ctrl.getList = function () {

        $ctrl.transactions = null;
        $ctrl.loading = true;

        let params = {
            startDate: moment($ctrl.startDate).format('YYYY-MM-DD HH:mm:ss'),
            endDate: moment($ctrl.endDate).format('YYYY-MM-DD HH:mm:ss')
        };

        let q = $httpParamSerializer(params);

        $ctrl.exportLink = '/control-panel/organizations/' + $ctrl.organization.id + '/export-transactions?' + q;

        Organization
            .getTransactions($ctrl.organization.id, params)
            .then(
                function (response) {
                    $ctrl.transactions = response.data;
                    $ctrl.loading = false;
                },
                function (error) {
                    notifier.errorResponseNotify(error);
                    $ctrl.loading = false;
                }
            )
    };

    $ctrl.openInfo = function (t) {
        $uibModal.open({
            component: 'transactionInfo',
            resolve: {
                transaction: function () {
                    return t;
                }
            }
        });
    };
}

export default 'organizationsControl.organizationTransactions';


// WEBPACK FOOTER //
// ./resources/assets/modules/organizations-control/organization-transactions/organizations-transactions.js